export const CA = "CByng7iW5jYNvSFnDQnhngmD4H1MSpvQm5bMDT9Rpump";

export const TELEGRAM_URL = "https://t.me/+DGeVAlmz98VlZWMx";

export const X_URL = "https://x.com/solmoosvj";

export const BUY_LINKS = [
  { name: "Pump.fun", url: `https://pump.fun/coin/${CA}`, testid: "buy-pumpfun-btn" },
  { name: "Axiom", url: "https://axiom.trade", testid: "buy-axiom-btn" },
];

export const NAV_LINKS = [
  { label: "Home", id: "top", testid: "nav-link-home" },
  { label: "About", id: "about", testid: "nav-link-about" },
  { label: "Tokenomics", id: "tokenomics", testid: "nav-link-tokenomics" },
  { label: "How To Buy", id: "how-to-buy", testid: "nav-link-how-to-buy" },
  { label: "Roadmap", id: "roadmap", testid: "nav-link-roadmap" },
  { label: "Community", id: "community", testid: "nav-link-community" },
  { label: "Official Links", id: "official-links", testid: "nav-link-official-links" },
];
